module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-nav"
  }, [_c('div', {
    staticClass: "orange-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "news-wrapper"
  }, [_c('div', {
    staticClass: "news-container"
  }, [_c('div', {
    staticClass: "news-content"
  }, [_vm._l((_vm.allAppNews), function(appNews) {
    return _c('div', {
      staticClass: "news-item"
    }, [_c('div', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy:background-image",
        value: (appNews.near_news_pic_url),
        expression: "appNews.near_news_pic_url",
        arg: "background-image"
      }],
      staticClass: "item-bg-img"
    }), _vm._v(" "), _c('div', {
      staticClass: "mask"
    }), _vm._v(" "), _c('div', {
      staticClass: "content",
      on: {
        "click": function($event) {
          _vm.openWeb(appNews.detail_href)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "news-list"
  }, [_c('router-link', {
    staticClass: "plus",
    attrs: {
      "to": "news"
    }
  }, [_c('span', [_vm._v("+")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.allNews.length > 0) ? _c('router-link', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": 'news/' + _vm.allNews[0].id
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.allNews[0].title))])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.allNews), function(news, index) {
    return (index >= 1 && index <= 5) ? _c('li', {
      staticClass: "li"
    }, [_c('router-link', {
      attrs: {
        "to": 'news/' + news.id
      }
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("[" + _vm._s(_vm.$t('typeNews')) + "] " + _vm._s(news.title))]), _vm._v(" "), _c('p', {
      staticClass: "date"
    }, [_vm._v(_vm._s(news.news_date))])])], 1) : _vm._e()
  }))], 1)], 1)], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e94b9680!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/GameNews.vue
// module id = 394
// module chunks = 1